import { WorkflowStatus } from '@makemydeal/dr-sales-checkin-types';
import { isMissingVehicle } from '@makemydeal/dr-sales-checkin-utils';
import type { WorkflowRule } from '../types';
import { getWorkflowInputsFromState } from '../workflowInputs';

// Default: showroom mode deal is in progress — show vehicle details. Mirrors the BFF's fallback
// branch, which reaches for the same predicate when no rule matched.
export const defaultRule: WorkflowRule = (state: any): WorkflowStatus | null =>
    isMissingVehicle(getWorkflowInputsFromState(state)) ? WorkflowStatus.MISSING_VEHICLE : WorkflowStatus.IN_PROGRESS;
